enum PaymentPaymentTypes {
  WIRE = "WIRE",
  ACH = "ACH",
  CHECK = "CHECK",
  CREDIT_CARD = "CREDIT_CARD",
}

export default PaymentPaymentTypes;
